export default {
    "lyrics": [
        {
            "characters": ["startup"],
            "time": "00:01",
            "lyric": "Oh life is nice"
        },
        {
            "characters": ["startup"],
            "time": "00:04",
            "lyric": "(audience cheers)"
        },
        {
            "characters": ["startup"],
            "time": "00:06",
            "lyric": "We have money and we will live another day"
        },
        {
            "characters": ["startup"],
            "time": "00:12",
            "lyric": "(audience continues cheering)"
        },
        {
            "characters": ["startup"],
            "time": "00:13",
            "lyric": "Oh life is nice"
        },
        {
            "characters": ["startup"],
            "time": "00:18",
            "lyric": "And the valley is great"
        },
        {
            "characters": ["startup"],
            "time": "00:24",
            "lyric": "(audience cheers)"
        },
        {
            "characters": ["startup"],
            "time": "00:28",
            "lyric": "Living in the valley"
        },
        {
            "characters": ["startup"],
            "time": "00:29",
            "lyric": "You could do whatever you will"
        },
        {
            "characters": ["startup"],
            "time": "00:31",
            "lyric": "And still you could trip on a $100 bill"
        },
        {
            "characters": ["startup"],
            "time": "00:34",
            "lyric": "And not so long ago"
        },
        {
            "characters": ["startup"],
            "time": "00:37",
            "lyric": "There were three groups of people"
        },
        {
            "characters": ["startup"],
            "time": "00:38",
            "lyric": "A well-oiled machine"
        },
        {
            "characters": ["startup"],
            "time": "00:40",
            "lyric": "It's hard to believe that it was real"
        },
        {
            "characters": ["startup"],
            "time": "00:42",
            "lyric": "The valley is great"
        },
        {
            "characters": ["startup"],
            "time": "00:40",
            "lyric": "It's hard to believe that it was real"
        },
        {
            "characters": ["startup"],
            "time": "00:45",
            "lyric": "Oh the valley"
        },
        {
            "characters": ["startup"],
            "time": "00:48",
            "lyric": "The valley is great"
        },
        {
            "characters": ["startup"],
            "time": "00:52",
            "lyric": "Yeah the valley is great!"
        },
        {
            "characters": ["startup"],
            "time": "00:57",
            "lyric": "The startup founders"
        },
        {
            "characters": ["startup"],
            "time": "00:59",
            "lyric": "We are one of them"
        },
        {
            "characters": ["startup"],
            "time": "01:01",
            "lyric": "Visionaries and young"
        },
        {
            "characters": ["startup"],
            "time": "01:03",
            "lyric": "Hearts full of Amen"
        },
        {
            "characters": ["startup"],
            "time": "01:05",
            "lyric": "The startup founders"
        },
        {
            "characters": ["startup"],
            "time": "01:07",
            "lyric": "To build companies"
        },
        {
            "characters": ["startup"],
            "time": "01:08",
            "lyric": "You may ask us"
        },
        {
            "characters": ["startup"],
            "time": "01:10",
            "lyric": "Where do you get your money?"
        },
        {
            "characters": ["startup"],
            "time": "01:12",
            "lyric": "How great is the valley?"
        },
        {
            "characters": ["startup"],
            "time": "01:15",
            "lyric": "How great it is?"
        },
        {
            "characters": ["startup"],
            "time": "01:18",
            "lyric": "How great is the valley?"
        },
        {
            "characters": ["startup"],
            "time": "01:23",
            "lyric": "Great is the valley"
        },
        {
            "characters": ["startup"],
            "time": "01:16",
            "lyric": "Great it is"
        },
        {
            "characters": ["vc"],
            "time": "01:27",
            "lyric": "The venture capitalists"
        },
        {
            "characters": ["startup"],
            "time": "01:29",
            "lyric": "-"
        },
        {
            "characters": ["vc"],
            "time": "01:30",
            "lyric": "And well, we maybe the stars of the night"
        },
        {
            "characters": ["vc"],
            "time": "01:32",
            "lyric": "We'll see"
        },
        {
            "characters": ["vc"],
            "time": "01:34",
            "lyric": "I'm in my Californian beach house"
        },
        {
            "characters": ["vc"],
            "time": "01:36",
            "lyric": "In a Hawaiian townhouse I'll be"
        },
        {
            "characters": ["vc"],
            "time": "01:37",
            "lyric": "Would you be a doll and get my groceries?"
        },
        {
            "characters": ["startup"],
            "time": "01:41",
            "lyric": "VCs give us money"
        },
        {
            "characters": ["vc"],
            "time": "01:43",
            "lyric": "Oh yeah we do!"
        },
        {
            "characters": ["startup"],
            "time": "01:45",
            "lyric": "For a share of our companies"
        },
        {
            "characters": ["vc"],
            "time": "01:47",
            "lyric": "It's me and you"
        },
        {
            "characters": ["vc"],
            "time": "01:49",
            "lyric": "Baby"
        },
        {
            "characters": ["startup"],
            "time": "01:49",
            "lyric": "How great is it?"
        },
        {
            "characters": ["vc"],
            "time": "01:53",
            "lyric": "Uuuuuh"
        },
        {
            "characters": ["vc", "startup"],
            "time": "01:56",
            "lyric": "How great is the valley?"
        },
        {
            "characters": ["vc", "startup"],
            "time": "02:01",
            "lyric": "And Greg is here!"
        },
        {
            "characters": ["vc"],
            "time": "02:03",
            "lyric": "-"
        },
        {
            "characters": ["startup"],
            "time": "02:03",
            "lyric": "It's your turn Greg"
        },
        {
            "characters": ["startup"],
            "time": "02:04",
            "lyric": "C'mon"
        },
        {
            "characters": ["startup"],
            "time": "02:06",
            "lyric": "C'mon (multiple times)"
        },
        {
            "characters": ["greg"],
            "time": "02:11",
            "lyric": "CEO of the Valley Bank"
        },
        {
            "characters": ["greg"],
            "time": "02:13",
            "lyric": "Not your average piggy bank"
        },
        {
            "characters": ["vc", "startup"],
            "time": "02:15",
            "lyric": "We praise thee o Greg in all its awe and grace"
        },
        {
            "characters": ["greg"],
            "time": "02:18",
            "lyric": "What do I do to relax?"
        },
        {
            "characters": ["greg"],
            "time": "02:20",
            "lyric": "I take so good care of all this cash"
        },
        {
            "characters": ["vc", "startup"],
            "time": "02:22",
            "lyric": "He'll care for you as a sheperd's embrace"
        },
        {
            "characters": ["greg"],
            "time": "02:25",
            "lyric": "Deposits. We'll take it"
        },
        {
            "characters": ["vc", "startup"],
            "time": "02:27",
            "lyric": "-"
        },
        {
            "characters": ["greg"],
            "time": "02:28",
            "lyric": "Funds. We'll take it"
        },
        {
            "characters": ["greg"],
            "time": "02:30",
            "lyric": "The Valley Bank will praise it"
        },
        {
            "characters": ["greg"],
            "time": "02:31",
            "lyric": "We will appraise it"
        },
        {
            "characters": ["greg"],
            "time": "02:33",
            "lyric": "Let's invest those funds in long term investments"
        },
        {
            "characters": ["greg"],
            "time": "02:35",
            "lyric": "Rates are glorious. Sit down"
        },
        {
            "characters": ["greg"],
            "time": "02:37",
            "lyric": "Sit down for some refreshments"
        },
        {
            "characters": ["greg"],
            "time": "02:40",
            "lyric": "-"
        },
        {
            "characters": ["startup"],
            "time": "02:41",
            "lyric": "So, how such a well-oiled machine"
        },
        {
            "characters": ["startup"],
            "time": "02:44",
            "lyric": "Gets kicked into high gear?"
        },
        {
            "characters": ["vc"],
            "time": "02:47",
            "lyric": "One day"
        },
        {
            "characters": ["vc"],
            "time": "02:49",
            "lyric": "A Tuesday won't be another Tuesday"
        },
        {
            "characters": ["startup", "vc"],
            "time": "02:51",
            "lyric": "After 40 years"
        },
        {
            "characters": ["startup"],
            "time": "02:55",
            "lyric": "In 24 hours, we witnessed"
        },
        {
            "characters": ["vc"],
            "time": "02:56",
            "lyric": "-"
        },
        {
            "characters": ["startup"],
            "time": "02:57",
            "lyric": "The 2nd biggest US bank failure in history"
        },
        {
            "characters": ["vc"],
            "time": "03:03",
            "lyric": "But life is nice"
        },
        {
            "characters": ["vc"],
            "time": "03:08",
            "lyric": "Great is the valley"
        },
        {
            "characters": ["startup"],
            "time": "03:11",
            "lyric": "Great is the valley"
        },
        {
            "characters": ["vc", "startup"],
            "time": "03:15",
            "lyric": "Great is the valley"
        },
        {
            "characters": ["startup"],
            "time": "03:21",
            "lyric": "How great?"
        },
        {
            "characters": ["vc", "startup"],
            "time": "03:26",
            "lyric": "How great is the valley?"
        },
        {
            "characters": ["startup"],
            "time": "03:30",
            "lyric": "How great it is? (multiple times)"
        },
        {
            "characters": ["startup"],
            "time": "03:35",
            "lyric": "How great is the valley?"
        },
        {
            "characters": ["vc"],
            "time": "03:37",
            "lyric": "One more time"
        },
        {
            "characters": ["startup"],
            "time": "03:38",
            "lyric": "Great is the valley"
        },
        {
            "characters": ["vc"],
            "time": "03:40",
            "lyric": "How great is it?"
        },
        {
            "characters": ["startup"],
            "time": "03:41",
            "lyric": "How great is the valley?"
        },
        {
            "characters": ["vc"],
            "time": "03:43",
            "lyric": "How great is it?"
        },
        {
            "characters": ["startup"],
            "time": "03:45",
            "lyric": "How great is the valley?"
        },
        {
            "characters": ["vc"],
            "time": "03:47",
            "lyric": "How great is it?"
        },
        {
            "characters": ["startup"],
            "time": "03:49",
            "lyric": "How great is the valley"
        },
        {
            "characters": ["startup"],
            "time": "03:52",
            "lyric": "Oh the valley is great"
        },
        {
            "characters": ["vc"],
            "time": "03:57",
            "lyric": "And life is nice"
        },
        {
            "characters": ["startup"],
            "time": "03:59",
            "lyric": "We have money and we'll live another day"
        }, 
        {
            "characters": ["startup"],
            "time": "04:03",
            "lyric": "Oh life is nice"
        }, 
        {
            "characters": ["vc", "startup"],
            "time": "04:08",
            "lyric": "And the valley is great!"
        }, 
    ]
}